import { Component, OnInit, Inject } from '@angular/core';
import { SchematicDataVM, GenericIdName, CrackStatusVM, SchematicType } from '../setup-implement/setup-implement.model';
import { DomSanitizer } from '@angular/platform-browser';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { NotificationsService } from 'angular2-notifications';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { AddCrackObsPointDialogComponent } from '../add-crack-obs-point-dialog/add-crack-obs-point-dialog.component';
import { ObservationPointVM } from '../favourite-dialog/favourite-dialog-modal';
import { GETPreferencesService } from '../preferences/preferences.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'schemantic-comptype-popup',
  templateUrl: './schemantic-comptype-popup.component.html',
  styleUrls: ['./schemantic-comptype-popup.component.scss']
})
export class SchemanticCompTypePopupComponent implements OnInit {

  schematic: SchematicDataVM = new SchematicDataVM();
  implementId: number;

  loading: boolean;
  schematicName: string;

  componentTypeList: GenericIdName[] = [];
  ComponentTypeVM: any[] = [0];
  originalComponentTypeVM: any[] = [0];
  ComponentTypeVMForm: FormControl = new FormControl(this.ComponentTypeVM);
  crackOptions: CrackStatusVM[] = [];
  allObservationPoints: any[] = [];
  activeCrackStatusIds: number[] = [];
  schematicObsPoints:SchematicDataVM = new SchematicDataVM();
  userUOM: string = "mm";
  schematics: SchematicType[] = [];
  
  constructor(
    private _sanitizer: DomSanitizer,
    private toastr: NotificationsService,
    public openObservationPointModel: MatDialog,
    private _implementService: SetupImplementService,
    public _dialogRef: MatDialogRef<SchemanticCompTypePopupComponent>,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userPrefService: GETPreferencesService ) { }

  ngOnInit() {
    this.getUserPref();
    this.schematic = this.data.schematic
    this.schematicName = this.schematic.ImageName;
    this.implementId = this.data.implementId;
    this.activeCrackStatusIds = this.data.activeCrackStatusIds;
    this.allObservationPoints = deepClone(this.schematic.ObservationPoints);
    this.schematicObsPoints = this.data.schematic;
    console.log("schematic", this.schematic);
    console.log("this", this.allObservationPoints);
    // this.loadComponentTypes();
    // this.loadAllSchematicsAndTypes();
    this.loadComponentTypesAndSchematics();
    this.getCrackStatuses();
    console.log("activeCrackStatusIds", this.activeCrackStatusIds);
    if(this.activeCrackStatusIds != undefined && this.activeCrackStatusIds.length > 0)
      this.applyCrackFilter();
    console.log("schematic after filter", this.schematicObsPoints);
  }
  /////////////////////////////
  // GET/SELECT METHODS //
  /////////////////////////////

  getUserPref() {
    this.userPrefService.getUserPreferences().subscribe(res => {
      //console.log('res', res);
      this.userUOM = res.UnitOfMeasurementName;
    });
  }

  loadComponentTypesAndSchematics() {

    forkJoin({
      componentTypes: this._implementService
        .GetComponentTypeListForSelectedImplement(this.implementId),
  
      schematics: this._implementService
        .getSchematicsAndTypes(this.implementId)
  
    }).subscribe({
      next: (res) => {
  
        this.componentTypeList = res.componentTypes;
        this.schematics = res.schematics;
  
        console.log(this.schematics);
  
        this.GetSchematicComponentTypeViewModelList();
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  // loadComponentTypes() {
  //   this._implementService.GetComponentTypeListForSelectedImplement(this.implementId).subscribe(r => {
  //     this.componentTypeList = r;
  //     this.GetSchematicComponentTypeViewModelList();
  //   });
  // }

  // loadAllSchematicsAndTypes() {
  //   this._implementService.getSchematicsAndTypes(this.implementId).subscribe({next: (res) => {
  //         this.schematics = res;
  //         console.log(res);
  //       },
  //       error: (err) => {
  //         console.error(err);
  //       }
  //     });
  // }

  getMappedSchematicName(componentTypeId: number): string {

    const mapped = this.schematics.find(x =>
      x.GETComponentTypeId === componentTypeId &&
      x.SchematicAuto !== this.schematic.Id
    );
  
    return mapped ? mapped.SchematicName : '';
  }

  isComponentTypeDisabled(componentTypeId: number): boolean {

    return this.schematics.some(x =>
      x.GETComponentTypeId === componentTypeId &&
      x.SchematicAuto !== this.schematic.Id
    );
  }


  // applyCrackFilter() {
  //   if (!this.allObservationPoints?.length) {
  //     this.schematic.ObservationPoints = [];
  //     return;
  //   }
  //   this.schematic.ObservationPoints =
  //     this.allObservationPoints.filter(op => {
  //       if (op.ObPointTypeId !== 2) {
  //         return true;
  //       }
  //       return this.activeCrackStatusIds.includes(op.CrackStatusId);
  //   });
  // } 

applyCrackFilter() {
  this.schematic.ObservationPoints =
    this.allObservationPoints.filter(op => {

      if (op.ObPointTypeId !== 2) {
        return true;
      }
      if (!this.activeCrackStatusIds || this.activeCrackStatusIds.length === 0) {
        return true;
      }
      return this.activeCrackStatusIds.includes(op.CrackStatusId);
    });
}



  GetSchematicComponentTypeViewModelList() {
    this.ComponentTypeVM = [];
    //console.log("this.schematic.Id:", this.schematic.Id);
    this._implementService.GetSchematicComponentTypeViewModelList(this.schematic.Id, this.implementId).subscribe(res => {
      res.forEach(x => {
        this.ComponentTypeVM.push(x.Id);
      });
      this.originalComponentTypeVM = [...this.ComponentTypeVM];
      this.ComponentTypeVMForm = new FormControl(this.ComponentTypeVM);
    });
  }

  /////////////////////////////
  // OBSERVASION POINTS METHODS //
  /////////////////////////////

  getPosition(posX: string, posY: string) {
    var iPX = (parseFloat(posX));
    var iPY = (parseFloat(posY));
    return {
      position: 'absolute',   // Add this if necessary for positioning
      left: `${iPX}px`,
      top: `${iPY}px`
    };
    //return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
  }

  getLine(posX: string, posY: string, EndposX: string, EndposY: string, isCrackFixed: boolean, cp: ObservationPointVM) {
    // bottom right
    var x1 = (parseFloat(posX))
    var y1 = (parseFloat(posY));
    // top right
    var x2 = (parseFloat(EndposX))
    var y2 = (parseFloat(EndposY));
    // distance
    var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
    // center
    var cx = (((x1 + x2) / 2) - (length / 2)) + 7;
    var cy = ((y1 + y2) / 2) - (4 / 2);
    // angle
    var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);
    // make hr
    var colour = cp.ColorCode != null ? cp.ColorCode : (isCrackFixed == false ? "#EC0A0A" : "#63c94b");
    return this._sanitizer.bypassSecurityTrustStyle('padding:0px; margin:0px; height:' + 4 +
      'px; background-color:' + colour + '; line-height:1px; position:absolute; left:' + cx +
      'px; top:' + cy + 'px; width:' + length + 'px; -moz-transform:rotate(' + angle + 'deg); -webkit-transform:rotate(' + angle + 'deg); -o-transform:rotate(' + angle + 'deg); -ms-transform:rotate(' + angle + 'deg); transform:rotate(' + angle + 'deg);');

  }

  getEval(wornPct: number, inspectDate: string) {
    if ((wornPct == 0) && (inspectDate == "Never")) {
      return 'gray';
    } else if (wornPct <= 30) {
      return 'green';
    } else if ((wornPct > 30) && (wornPct <= 60)) {
      return 'yellow';
    } else if ((wornPct > 60) && (wornPct <= 80)) {
      return 'orange';
    } else if (wornPct > 80) {
      return 'red';
    }
    else {
      return 'magenta';
    }
  }

  /////////////////////////////
  // SAVE/UPDATE METHODS //
  /////////////////////////////

  saveUpdateComponentType() {
    const currentValues: number[] = this.ComponentTypeVMForm.value || [];
    if (!this.hasComponentTypeChanged(this.originalComponentTypeVM, currentValues) && this.schematicName == this.schematic.ImageName) {
      return;
    }
    
    const schematicComponentTypeModelsList: any[] = [];
    for (let items of currentValues) {
      var x = {
        SchematicId: this.schematic.Id,
        componentTypeId: items,
        ImplementId: this.implementId
      };
      schematicComponentTypeModelsList.push(x)
    }
    if (this.hasComponentTypeChanged(this.originalComponentTypeVM, currentValues)) {
      this.loading = true;
      this._implementService.saveUpdateComponentType(schematicComponentTypeModelsList).subscribe(r => {
        if (r) {
          this.loading = false;
          this.toastr.success('Component types updated successfully.');
          this._dialogRef.close(true);
          //this.saveObservation.emit(true);
          //this.closeSchematicWindow.emit(true);
        } else {
          this.toastr.error('Unable to update component types!');
          this.loading = false;
        }
      });
    }
    
    this.UpdateSchmaticImageName();
  }

  UpdateSchmaticImageName() {
    if (this.schematicName != this.schematic.ImageName) {
      this._implementService.UpdateSchmaticImageName(this.schematic.Id, this.schematicName).subscribe(res => {
        console.log("UpdateSchmaticImageName res", res);
        if (res) {
          this.toastr.success("Schematic name updated successfully.");
          this._dialogRef.close(true);
        }
        else {
          this.toastr.error('Unable to update schematic name!');
        }
      });
    }
  }

  /////////////////////////////
  // POPUP OPEN/CLOSE METHODS //
  /////////////////////////////

  openSchematicAndObservationPointDetailsWindow() {
    let arr_ = [];
    this._implementService.ReturnGETSchematicComponents(this.implementId, this.schematic.Id).subscribe(result => {
      var componentList = result
      //this.schematic.ObservationPoints.map(x => {
      console.log('this.allObservationPoints', this.allObservationPoints);
      this.allObservationPoints.map(x => {
        var neModl = new ObservationPointVM();
        neModl.ObservationPointId = x.Id;
        neModl.ObservationPointPosX = x.PositionX;
        neModl.ObservationPointPosY = x.PositionY;
        neModl.EndObservationPointPosX = x.EndPositionX == 0 ? null : x.EndPositionX;
        neModl.EndObservationPointPosY = x.EndPositionY == 0 ? null : x.EndPositionY;
        neModl.isCrackFixed = x.IsCrackFixed;
        neModl.ObservationPointName = x.Name;
        neModl.observationPointTypeId = x.ObPointTypeId;
        neModl.WornPct = x.WornPct;
        neModl.InspectionDate = x.InspectionDate;
        neModl.pointLedgend = 3;
        neModl.CrackStatusId = x.CrackStatusId;
        neModl.ColorCode = x.ColorCode;
        neModl.CrackStatus = x.CrackStatus;
        neModl.CurrentLength = x.CurrentLength;
        neModl.InstallDate = x.InstallDate;
        neModl.CrackSeverity = x.CrackSeverity;
        arr_.push(neModl)
      });
      console.log("arr_", arr_);
      this._dialogRef.close(false);
      const addSectionDialog = this._dialog.open(AddCrackObsPointDialogComponent, {
        width: '1300px',
        //height: '1075px',
        disableClose: true,
        data: {
          obsDetails: arr_,
          schematic: this.schematic.Data,
          componentList: componentList,
          schematicId: this.schematic.Id,
          IsGETInspection: true,
          //inspectionDate: this.implementToBeInspected.InspectionDate,
          //implementInspectionId: this.implementToBeInspected.ImplementInspectionId,
          isGlobalImg: true,
          implementId: this.implementId,
          activeCrackIds: this.activeCrackStatusIds,
          TypeID: 1,
          disabledCrackOption: false,
          
        }
      });
      addSectionDialog.afterClosed().subscribe(ObsID => {
        if (ObsID > 0) {
          //console.log("details", ObsID)

          //this._inspectionService.recordComponentInspectionForObsPoint(ObsID, this.implementInspectionID).subscribe(res => {
          //        //console.log(res)
          //        //this.updateObs.emit(true);
          //        //this.loadImplementDetails();
          //})
        } else {

        }
      });
    });
  }

  onCloseClick(): void {
    this._dialogRef.close(false);
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  private hasComponentTypeChanged(original: number[], current: number[]): boolean {
    if (original.length !== current.length) {
      return true;
    }
    const sortedOriginal = [...original].sort();
    const sortedCurrent = [...current].sort();
    return !sortedOriginal.every((value, index) => value === sortedCurrent[index]);
  }

  getCrackStatuses() {
    this._implementService.getCrackStatuses().subscribe({
      next: (res: CrackStatusVM[]) => {

        this.crackOptions = res.map(x => ({
          ...x,
          isSelected:
            this.activeCrackStatusIds?.length
              ? this.activeCrackStatusIds.includes(x.Id)
              : true // default = checked
        }));

        this.applyCrackFilter();
      },
      error: err => console.error(err)
    });
  }

  onCrackChange() {
    this.activeCrackStatusIds = this.crackOptions.filter(o => o.isSelected).map(o => o.Id);
    this.applyCrackFilter();
  }
}

export function deepClone<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}
